export class UserLogin {
  username: string = '';
  password: string = '';
  confirmPassword?: string = '';
}
